export const FETCH_WITHDRAW_ADDRESS_SUCCESS = 'FETCH_WITHDRAW_ADDRESS_SUCCESS';
export const FETCH_WITHDRAW_ADDRESS_ERROR = 'FETCH_WITHDRAW_ADDRESS_ERROR';